import { render, staticRenderFns, recyclableRender, components } from "./answer.vue?vue&type=template&id=514287f4&scoped=true&"
var renderjs
import script from "./answer.vue?vue&type=script&lang=js&"
export * from "./answer.vue?vue&type=script&lang=js&"
import style0 from "./answer.vue?vue&type=style&index=0&id=514287f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514287f4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/answer/answer.vue"
export default component.exports